import { template } from "@ember/template-compiler";
import { LinkTo } from '@ember/routing';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { models, route } from 'parog-web/helpers/transition-to-forc';
import type Patient from 'parog-web/models/patient';
import type SemeiaSessionService from 'parog-web/services/session';
export interface Signature {
    Element: HTMLAnchorElement;
    Args: {
        feature: string;
        component: string;
        patient: Patient | string;
        sourceJeId?: string;
        originJournalEventId?: string;
        originJournalEventType?: string;
        asModal?: boolean;
        isReadOnly?: boolean;
        class?: string;
        replace?: boolean;
        query?: object;
    };
    Blocks: {
        default: [];
    };
}
export default class LinkToForcComponent extends Component<Signature> {
    @service
    session: SemeiaSessionService;
    @service
    router: RouterService;
    get route() {
        return route(this.args.sourceJeId, this.args.asModal, this.session);
    }
    get models() {
        return models(this.args.feature, this.args.component, this.args.patient, this.args.sourceJeId, this.session);
    }
    get query() {
        return Object.assign({}, this.args.query, {
            isReadOnly: this.args.isReadOnly,
            originJournalEventType: this.args.originJournalEventType,
            originJournalEventId: this.args.originJournalEventId
        });
    }
    static{
        template(`
    <LinkTo
      @route={{this.route}}
      @models={{this.models}}
      @query={{this.query}}
      class={{@class}}
      @replace={{@replace}}
      ...attributes
      data-test-link-to-forc='{{@feature}}/{{@component}}'
    >
      {{yield}}
    </LinkTo>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
